const V = {
    ellieAttia:
        "https://customer-assets.emergentagent.com/job_linkedin-content-hub-3/artifacts/qllhtsbj_Ellie%20Attia%20Banque%20privee%20video%20short%20ceo.mp4",
    edouard:
        "https://customer-assets.emergentagent.com/job_linkedin-content-hub-3/artifacts/t9ty6961_Edouard%20Bauman%20Video%20ecrite%20par%20Fabien%20Moutier%20Personnal%20Branding%20.mp4",
    lola: "https://customer-assets.emergentagent.com/job_linkedin-content-hub-3/artifacts/yfaybbhg_IA%20Short%20Video%20Personal%20branding%20Lola.mp4",
};

export const CITIES = [
    {
        slug: "personal-branding-geneve",
        city: "Genève",
        region: "GE · Suisse romande",
        studioImg: "/images/studios/geneve.avif",
        metaTitle:
            "Personal Branding Genève — Shorts & vidéos courtes LinkedIn pour dirigeants | Brand Your Expertise",
        metaDescription:
            "Agence de personal branding à Genève. Shorts et vidéos courtes LinkedIn pour dirigeants, écrites et pilotées de A à Z par Fabien Moutier. Studio à Genève. Réservez un rendez-vous.",
        keywords:
            "personal branding Genève, shorts vidéos Genève, vidéos courtes LinkedIn Genève, agence vidéo dirigeant Genève",
        eyebrow: "Personal Branding · Genève",
        h1: "Personal branding à",
        h1Accent: "Genève",
        intro:
            "À Genève, l'excellence est un standard. Nous créons pour les dirigeants genevois des shorts et vidéos courtes LinkedIn qui transforment l'expertise en autorité — de la stratégie au montage, tout est piloté pour vous.",
        bullets: [
            "Studio premium au cœur de Genève, équipement broadcast.",
            "Écriture et stratégie signées Fabien Moutier.",
            "Un flux de vidéos courtes prêtes à générer des rendez-vous.",
        ],
        cases: [
            {
                client: "Ellie Attia",
                tag: "CEO · Banque privée",
                country: "Suisse",
                videoSrc: V.ellieAttia,
                realisation: "Agence Personnelle",
            },
            {
                client: "Édouard Bauman",
                tag: "Dirigeant · Personal Branding",
                country: "Suisse",
                videoSrc: V.edouard,
                realisation: "Agence Personnelle",
            },
        ],
        faq: [
            {
                q: "Où se déroule le tournage à Genève ?",
                a: "Dans notre studio premium au cœur de Genève, ou en déplacement selon votre agenda. Une demi-journée suffit pour produire 20+ shorts.",
            },
            {
                q: "Pour quels dirigeants genevois ?",
                a: "Banque privée, gestion de patrimoine, avocats, immobilier, santé : tout dirigeant qui veut transformer son expertise en présence LinkedIn.",
            },
        ],
    },
    {
        slug: "personal-branding-lausanne",
        city: "Lausanne",
        region: "Vaud · Suisse romande",
        studioImg: "/images/studios/lausanne.jpg",
        metaTitle:
            "Personal Branding Lausanne — Shorts & vidéos courtes LinkedIn pour dirigeants | Brand Your Expertise",
        metaDescription:
            "Agence de personal branding à Lausanne. Shorts et vidéos courtes LinkedIn pour dirigeants, écrites et pilotées de A à Z par Fabien Moutier. Studio à Lausanne. Réservez un rendez-vous.",
        keywords:
            "personal branding Lausanne, shorts vidéos Lausanne, vidéos courtes LinkedIn Lausanne, agence vidéo dirigeant Lausanne",
        eyebrow: "Personal Branding · Lausanne",
        h1: "Personal branding à",
        h1Accent: "Lausanne",
        intro:
            "À Lausanne, nous accompagnons les dirigeants romands avec des shorts et vidéos courtes LinkedIn à leur voix. De la stratégie au posting, un seul interlocuteur pilote tout — vous restez concentré sur votre business.",
        bullets: [
            "Studio chaleureux signature à Lausanne, ambiance feutrée.",
            "Écriture et stratégie signées Fabien Moutier.",
            "Des vidéos courtes pensées pour convertir en rendez-vous.",
        ],
        cases: [
            {
                client: "Édouard Bauman",
                tag: "Dirigeant · Personal Branding",
                country: "Suisse",
                videoSrc: V.edouard,
                realisation: "Agence Personnelle",
            },
            {
                client: "Lola",
                tag: "Founder · Tech",
                country: "Suisse",
                videoSrc: V.lola,
                realisation: "Agence Personnelle",
            },
        ],
        faq: [
            {
                q: "Où se déroule le tournage à Lausanne ?",
                a: "Dans notre studio chaleureux signature à Lausanne, ou en déplacement. Une demi-journée produit généralement 20 à 24 shorts.",
            },
            {
                q: "Faut-il de l'expérience face caméra ?",
                a: "Non. Direction, cadre, prompteur et énergie : je suis présent au tournage. Vous lisez, vous validez, on s'occupe du reste.",
            },
        ],
    },
];

export const getCity = (slug) => CITIES.find((c) => c.slug === slug);
